import { render, staticRenderFns } from "./RegistryContacts.vue?vue&type=template&id=b3bdc2b2"
import script from "./RegistryContacts.vue?vue&type=script&lang=js"
export * from "./RegistryContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3bdc2b2')) {
      api.createRecord('b3bdc2b2', component.options)
    } else {
      api.reload('b3bdc2b2', component.options)
    }
    module.hot.accept("./RegistryContacts.vue?vue&type=template&id=b3bdc2b2", function () {
      api.rerender('b3bdc2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryContacts.vue"
export default component.exports